import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { useContext, useState, useRef } from 'react';
import { TabsContext } from './context.js';
import { useFocusTab } from './hooks/useFocusTab.js';
import { useHandleKeyDown } from './hooks/useHandleKeyDown.js';
import { useInsertRemoveTabs } from './hooks/useInsertRemoveTabs.js';
import { TabsMenusWrapper } from './styles.js';

function TabsMenus(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    const ctx = useContext(TabsContext);
    const [focusedTabIndex, setFocusedTabIndex] = useState(0);
    const [isTabFocused, setIsTabFocused] = useState(false);
    const tabsRef = useRef([]);
    const filteredChildren = Array.isArray(children)
        ? children.filter((item) => item)
        : [children];
    useFocusTab({ tabsRef, context: ctx, isTabFocused, setFocusedTabIndex }, [
        isTabFocused,
    ]);
    useInsertRemoveTabs({
        tabsRef,
        context: ctx,
        setIsTabFocused,
        focusedTabIndex,
        setFocusedTabIndex,
    }, [children]);
    const handleForwardRef = ({ child, nodeRef, tabIndex }) => {
        const { ref } = child;
        tabsRef.current[tabIndex] = nodeRef;
        tabsRef.current = tabsRef.current.filter((item) => item);
        if (ref) {
            ref.current = nodeRef;
        }
    };
    const [handleKeyDown] = useHandleKeyDown({
        tabsRef,
        focusedTabIndex,
        setFocusedTabIndex,
    });
    let handleBlurTimeout;
    const handleBlur = () => {
        handleBlurTimeout = setTimeout(() => {
            if (isTabFocused) {
                setIsTabFocused(false);
            }
        }, 0);
    };
    const handleFocus = () => {
        clearTimeout(handleBlurTimeout);
        if (!isTabFocused) {
            setIsTabFocused(true);
        }
    };
    return (React.createElement(TabsMenusWrapper, Object.assign({}, rest, { role: "tablist", "aria-orientation": "horizontal", onBlur: handleBlur, onFocus: handleFocus, onKeyDown: handleKeyDown }), React.Children.map(filteredChildren, (child, index) => {
        const tabIndex = index;
        return React.cloneElement(child, {
            ref: (nodeRef) => {
                handleForwardRef({ child, nodeRef, tabIndex });
            },
            setFocusedTabIndex: () => {
                setFocusedTabIndex(tabIndex);
            },
        });
    })));
}

export { TabsMenus as default };
